export const paths = {
  home: '/',
  members: '/panel',
  agent: '/agent',
  copilot: '/copilot',
  calls: '/calls',
  mtls: '/mtls',
  knowledgeBase: '/knowledge-base',
  knowledgeBaseDocuments: '/knowledge-base/:catalogId/documents',
  knowledgeBaseUrlPaths: '/knowledge-base/:catalogId/documents/:documentId/url-paths',
  pipeline: '/pipeline',
  pipelineCreate: '/application/create/pipelinename',
  pipelineDocuments: '/pipeline/:catalogId/documents',
  pipelineUrlPaths: '/pipeline/:catalogId/documents/:documentId/url-paths',
  accessGroups: '/permission-groups',
};
